<template>
  <div class="MemberMenuCount">
    <template v-if="type == 'homework'">
      <el-badge
        v-if="$store.state.homeworkState.count > 0"
        :value="$store.state.homeworkState.count_show"
      />
    </template>
    <template v-if="type == 'message'">
      <el-badge
        v-if="$store.state.message.all.not_read > 0"
        :value="$store.state.message.all.not_read_show"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'MemberMenuCount',
  props: {
    type: String,
  },
};
</script>

<style lang="scss" scoped>
.MemberMenuCount {
  display: inline-block;
  position: absolute;
  right: 16px;
}
::v-deep.el-badge__content {
  background-color: #ff2b4e;
  margin-bottom: 2px;
  min-width: 7px;
  border: none;
  padding: 0px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  line-height: 22px;
}
</style>
